import {Boards} from './Boards.js';
import {BoardPost} from './BoardPost.js';
import {Template} from './Template.js';

export class Message {
	constructor(boardEl, parent, message) {
		console.log(`Message; message=`, message);
		this.board = boardEl;
		this.parent = parent;
		this.message = message;
		[this.el, this.$] = Template(`Message`);
		this.$.user.innerText = message.user;
		this.$.date.innerText = message.date;
		console.log(`message.content = `, message.content);
		let content = message.content;
		content = content.replaceAll('&nbsp;', ' ');
		// content = content.replace(/<\/?p>/, '<br>');
		console.log(`replace content = `, content);
		this.$.message.innerHTML = content;

		this.$.reply.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			BoardPost.post(message.board_id, message.id).then( res=> {
				if (res) {
					const m = new Message(boardEl, this.$.replies, res[0]);
					m.scrollIntoView();
				}
			});
		});
		this.$.delete.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			// console.log(`Going to delete post `, message.id);
			Boards.API().DeleteMessage(message.id).then(res=>{
				this.el.remove();
			});
		});
		this.$.hidereplies.addEventListener(`click`, evt=>{
			evt.stopPropagation();
			this.el.classList.toggle(`hidereplies`);
			// this.$.hidereplies.innerText = (this.el.classList.contains(`hidereplies`)?'show':'hide') + ` replies`;
		});

		parent.appendChild(this.el);

		this.message.replies.forEach( r=>{
			new Message(boardEl, this.$.replies, r);
		});
	}
	scrollIntoView() {
		this.el.scrollIntoView();
	}
}